<template>
    <div class="star-wapper" @click="handleClick">
        <span v-if="rated" class="icon is-medium star-rated">
            <!-- <svg style="width:28px;height:28px" viewBox="0 0 24 24">
                <path fill="#ffd930" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
            </svg> -->
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.6808 10.4754C23.2378 9.89095 22.9083 8.92143 22.1105 8.79737L16.2619 7.88783C15.9378 7.83743 15.659 7.63127 15.5158 7.33613L12.8682 1.87756C12.5018 1.12215 11.4238 1.12726 11.0646 1.8861L8.46716 7.37288C8.32692 7.66913 8.05041 7.87784 7.72707 7.93151L1.88529 8.90118C1.08903 9.03335 0.769373 10.0058 1.33191 10.5846L5.61431 14.9911C5.83216 15.2153 5.93266 15.5284 5.88595 15.8375L4.95428 22.0026C4.8306 22.8211 5.69797 23.4268 6.42377 23.0289L11.5751 20.2049C11.8714 20.0424 12.2298 20.0406 12.5277 20.2001L17.7058 22.9716C18.4353 23.3621 19.2963 22.7482 19.1651 21.9313L18.1759 15.7743C18.1263 15.4659 18.2238 15.152 18.4393 14.9258L22.6808 10.4754Z" fill="url(#paint0_radial)"/>
                <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M14.207 4.63761L12.8682 1.87755C12.5018 1.12214 11.4239 1.12725 11.0647 1.88609L8.46722 7.37288C8.32698 7.66912 8.05047 7.87783 7.72713 7.9315L1.88535 8.90117C1.08909 9.03334 0.769434 10.0058 1.33197 10.5846L5.61437 14.9911C5.83222 15.2153 5.93272 15.5284 5.88601 15.8375L4.95434 22.0026C4.83066 22.821 5.69803 23.4268 6.42383 23.0289L9.89813 21.1242C9.31701 19.5254 9.00006 17.7997 9.00006 16C9.00006 11.4584 11.0184 7.3883 14.207 4.63761Z" fill="url(#paint1_linear)"/>
                <defs>
                <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.7273 8.18182) rotate(108.043) scale(18.451 31.0184)">
                <stop offset="0.179804" stop-color="#FFC962"/>
                <stop offset="0.722476" stop-color="#ED582A"/>
                </radialGradient>
                <linearGradient id="paint1_linear" x1="4.84127" y1="18.0308" x2="12.5148" y2="5.00869" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FCFF71" stop-opacity="0.76"/>
                <stop offset="1" stop-color="white" stop-opacity="0.83"/>
                </linearGradient>
                </defs>
            </svg>

        </span>
        <span v-else class="icon is-medium">
            <!-- <svg style="width:28px;height:28px" viewBox="0 0 24 24">
                <path fill="#000000" d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z" />
            </svg> -->
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M34.6808 15.021C35.2378 14.4366 34.9083 13.467 34.1105 13.343L24.1341 11.7915C23.81 11.7411 23.5312 11.5349 23.3881 11.2398L18.8469 1.87756C18.4805 1.12215 17.4026 1.12726 17.0433 1.8861L12.5888 11.2958C12.4486 11.592 12.172 11.8008 11.8487 11.8544L1.88529 13.5082C1.08903 13.6404 0.769373 14.6128 1.33191 15.1917L8.59435 22.6645C8.8122 22.8887 8.9127 23.2018 8.86599 23.5109L7.2805 34.0026C7.15682 34.821 8.02419 35.4268 8.74999 35.0289L17.6002 30.1771C17.8965 30.0146 18.2548 30.0128 18.5528 30.1723L27.4485 34.9336C28.1779 35.3241 29.0389 34.7102 28.9077 33.8933L27.2245 23.4167C27.1749 23.1082 27.2724 22.7943 27.4879 22.5682L34.6808 15.021Z" fill="#BCBCBC"/>
                <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M14.8472 31.6864C13.9755 29.2881 13.5001 26.6995 13.5001 24C13.5001 17.1877 16.5276 11.0825 21.3105 6.95641L18.847 1.87755C18.4806 1.12214 17.4026 1.12725 17.0434 1.88609L12.5889 11.2958C12.4486 11.592 12.1721 11.8007 11.8488 11.8544L1.88535 13.5082C1.08909 13.6404 0.769434 14.6128 1.33197 15.1917L8.59441 22.6645C8.81226 22.8887 8.91276 23.2018 8.86605 23.5109L7.28056 34.0026C7.15688 34.821 8.02425 35.4268 8.75005 35.0289L14.8472 31.6864Z" fill="url(#paint0_linear)"/>
                <defs>
                <linearGradient id="paint0_linear" x1="6.88891" y1="27.2158" x2="18.8143" y2="7.10372" gradientUnits="userSpaceOnUse">
                <stop stop-color="white" stop-opacity="0"/>
                <stop offset="1" stop-color="white" stop-opacity="0.83"/>
                </linearGradient>
                </defs> 
            </svg>

        </span>
    </div>
</template>

<script>
export default {
    name: 'Star',
    props: {
        rated: Boolean,
        value: Number,
        onClick: Function
    },
    methods: {
        handleClick() {
            this.$emit('onClick', this.value)
        }
    }
}
</script>

<style lang="scss" scoped>
    .star-wapper {
        cursor: pointer;

        .star-rated {
            color: #f37336;
        }
    }
</style>
